import { Grid } from "@chakra-ui/react";
import "@uiw/react-markdown-preview/markdown.css";
import MarkdownEditor from "@uiw/react-md-editor";
import "@uiw/react-md-editor/markdown-editor.css";
import { useEffect, useState } from "react";
import remarkBreaks from "remark-breaks";

const JobDescriptionEditor = ({ value, valueFunc }) => {
  const [editorState, setEditorState] = useState("");
  useEffect(() => {
    if (value) {
      setEditorState(value);
    } else {
      setEditorState("");
    }
  }, [value]);
  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    valueFunc && valueFunc(newEditorState);
  };

  return (
    <Grid>
      <MarkdownEditor
        value={editorState}
        onChange={onEditorStateChange}
        height={400}
        previewOptions={{
          remarkPlugins: [remarkBreaks],
        }}
      />
    </Grid>
  );
};

export default JobDescriptionEditor;
